import React, { useEffect, useState} from "react";
import { BsPlus, BsCartFill, BsFillHeartFill, BsBellFill, BsFillPenFill, BsDash} from "react-icons/bs";
import { Link, useLocation } from "react-router-dom";
import Sheet from 'react-modal-sheet';
import {alert, confirm} from "../components/MegConfirmAlert";
import Star from "../components/Star";
import { useTranslation } from 'react-i18next';

export default function Product3 (props){
    
    const { t } = useTranslation();
    const [cnt, setCnt] = useState(props.cnt||0);
    
    const fnPuls = () =>{
    
        if(props.checkOrderCnt){
            if(!props.checkOrderCnt(props.obj,1)){
                return;
            }
        }

        if(cnt < Number(props.obj.sleQy)){
            setCnt(cnt+1)
        }
        
    }

    const fnMinus = () =>{
        if(cnt> 1){
            setCnt(cnt-1)
        }
        
    }

    useEffect(() => {

        

        if(cnt > props.obj.sleQy){
            setCnt(props.obj.sleQy)
        }

        if(props.obj && props.setTotalAmt){                      
            props.setTotalAmt(
                {
                    goodsOptnSn : props.obj.goodsOptnSn,
                    goodsSn : props.obj.goodsSn,
                    orderQy : cnt,
                    amount : props.obj.sleAmount,
                    amt : cnt * props.obj.sleAmount
                },props.obj.goodsOptnSn)
        }
      }, [cnt]);

    if (props.type==='type7') {
        return(
            
            <li onClick={(e)=> {e.stopPropagation(); props.clickSelect(props.obj); }}>
                <div className="ptWr soldOut">
                    <div className="dfsbG12">
                        <p className="prodName">{props.prodName}</p>
                        <p className="disprice">{props.disprice}</p>
                    </div>
                    <div className="qtyStatusWr">
                        <span className="tagList">
                            { props.blue && <p className="cBlue">판매수량</p> }
                            { (props.soldOut === false && props.red) && <p className="cRed">품절임박</p> }
                            { props.soldOut && <p className="cRed">품절되었습니다</p> }
                        </span>
                        { props.sleQy > 0 &&
                        <p className="qtyTxt">{props.sleQy}개 남았습니다</p>
                        }
                    </div>
                </div>
            </li>
            
        );
    } else if (props.type==='type8') {
        return(
            <Link to={"/ProductDetail/"+props.obj.goodsSn}  className="prodType8">
                <div className="imgWr">
                    <img src={props.img} alt="상품" />
                </div>
                <div className="infoWr">
                    <p className="prodName">{props.prodName}</p>
                    <div className="optionWr">
                        <p className="option">{props.option1}</p>
                        <p className="option">{props.option2}</p>
                    </div>
                </div>
                <div className="btn2424 pen"  onClick={(e) => {
                                        e.preventDefault(); 
                                        e.stopPropagation();
                                        if(props.clickPen){
                                            props.clickPen(props.obj)
                                        }
                                    }} ><BsFillPenFill /></div>
            </Link>
        );
    } else if (props.type==='type9') {
        return(
            <div className="prodType9">
                <div className="dfsbG12 w100per">
                    <div className="prodInfo">
                        <p className="prodName">{props.prodName}</p>
                        <div className="priceWr">
                            <p className="cost">{props.cost}</p>
                           
                            <p className="disprice">{props.disprice}</p>
                        </div>
                    </div>
                    <div className="pmBtnWr">
                        <button type="button" className={"minus "+(cnt === 1 ? "disabled":"")} onClick={fnMinus}><BsDash /></button>
                        <p className="num">{cnt}</p>
                        <button type="button" className={"plus "+(cnt === props.obj.sleQy ? "disabled":"")} onClick={fnPuls}><BsPlus /></button>
                    </div>
                </div>
                <div className="dfsbG20 w100per">
                    <div className="qtyStatusWr">
                        <span className="tagList">
                            { props.blue && <p className="cBlue">판매수량</p> }
                            { (props.soldOut === false && props.red)  && <p className="cRed">품절임박</p> }
                            { props.soldOut && <p className="cRed">품절되었습니다</p> }
                        </span>
                        { props.sleQy > 0 &&
                        <p className="qtyTxt">{props.sleQy}개 남았습니다</p>
                        }
                    </div>
                    { props.btnX &&
                    <div>
                        <button type="button" className="btnX" onClick={(e)=>props.btnXClick(props.obj)} ><span className="hide">삭제</span></button>
                    </div>
                    }
                </div>
            </div>
        )
    }
};